import { AppRoutes } from '../common/constants';
import { Box, Card, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { JSX } from 'react';
import { LoadingButton } from '@mui/lab';
import { useCreateNewFna } from '../common/components/mutations';
import { useNavigate } from 'react-router-dom';
import Content from '../common/components/content';
import FNAs from './FNAs';
import Layout from '../common/components/layout';

const breadcrumbs = [{ label: 'Financial needs analyses', href: AppRoutes.FNAs }];

/**
 * Page with FNA list and CTA button to create a new FNA
 */
const FNAsPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { mutate, isPending } = useCreateNewFna();

  const handleCreateFna = (): void => {
    mutate(
      { stateID: 1 },
      {
        onSuccess(fna) {
          navigate(`${AppRoutes.FNAs}/${fna.id}`);
        },
      },
    );
  };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <Content>
        <Box className="flex items-center justify-between">
          <Typography variant="h2">Financial needs analyses</Typography>
          <Box>
            <LoadingButton
              loading={isPending}
              size="large"
              variant="contained"
              color="secondary"
              onClick={handleCreateFna}
              endIcon={<Icon icon="uil:plus" />}
            >
              New
            </LoadingButton>
          </Box>
        </Box>

        <Card className="mt-4 pt-4">
          <FNAs editable />
        </Card>
      </Content>
    </Layout>
  );
};
export default FNAsPage;
